export const state = () => ({
  ready: false,
  flags: {}
})

export const mutations = {
  SET_READY_STATE (state, ready) {
    state.ready = ready
  },
  SET_FLAGS (state, flags) {
    state.flags = flags
  }
}

export const getters = {
  ready: state => state.ready,
  flags: state => state.flags
}